import React from 'react'
import { number, oneOf } from 'prop-types'
import * as Styled from './IndicatorIcon.styles'

const IndicatorIcon = ({ type, value, size }) => {
  const getIconContent = () => {
    // unterdurchschnittlich
    if ('low' === value || 1 === value) {
      return '-'
    }
    // durchschnittlich
    if ('average' === value || 2 === value) {
      return 'o'
    }
    // überdurchschnittlich
    return '+'
  }

  return (
    <Styled.IndicatorIcon type={ type } value={ value } size={ size }>
      {'qsr' === type && <span>{getIconContent()}</span>}
    </Styled.IndicatorIcon>
  )
}

IndicatorIcon.defaultProps = {
  size: 24,
}

IndicatorIcon.propTypes = {
  type: oneOf(['qsr', 'iqtig']).isRequired,
  value: oneOf([
    'low',
    'average',
    'high',
    'positive',
    'critical',
    'negative',
    'goodRating',
    'problematicRating',
    'noRating',
    'info',
    1,
    2,
    3,
  ]),
  size: number,
}

export default IndicatorIcon
